import React, { Component } from 'react';
import { connect } from 'react-redux';

export class BookMarkPane extends Component {
  render() {
    return (
      <div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(BookMarkPane);
